<template>
  <div class="toast">
    <img :src="loadCross" class="icon" alt="Icône" />
    <p class="message">
      {{ message }}
    </p>
    <div v-on:click="close" class="cross">
      <span class="cross-title"> X </span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ErrorAction } from '@/modules/ErrorToaster/store/actions-types';

export default defineComponent({
    props: {
        message: String,
    },
    computed: {
        loadCross() {
            return require('@/assets/img/warning.png');
        },
    },
    methods: {
        close() {
            this.$store.dispatch(`errorToaster/${ErrorAction.DEACTIVATE_TOAST}`);
        },
    },
});
</script>

<style>
.icon {
  height: 50px;
  margin: 10px;
}
.message {
    color: white;
}
.cross{
    position: absolute;
    top: 10px;
    right: 10px;
    height: 20px;
    width: 20px;
    cursor: pointer;
}
.cross-title{
    color: white;
}
.toast {
  display: flex;
  padding: 5px;
  position: fixed;
  left: 50px;
  background-color: var(--etat-rouge);
  width: 300px;
  border-radius: 10px;
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  align-items: center;
  animation: slidein 0.4s ease-in-out forwards;
  z-index: 999;
}
@keyframes slidein {
  from {
    bottom: -100px;
  }

  to {
    bottom: 40px;
  }
}
</style>
